import initReportsShow from '../common/reports_show'

Styxie.Initializers.StatsReports = {
  show: initReportsShow
}
